/* HD Warenkorb – seitliches Fenster (Handy: von unten).
   Ersetzt Dawns <cart-notification>: product-form.js und die Produktkarten rufen
   getSectionsToRender() / renderContents() auf, genau wie beim Dawn-Warenkorb. */
(function () {
  if (customElements.get('cart-drawer')) return;

  /* Dawns kleinen Warenkorb-Hinweis im Kopf entfernen, bevor product-form.js startet –
     sonst würde Dawn den alten Hinweis statt des HD-Warenkorbs öffnen. */
  if (document.querySelector('[data-hdcart]')) {
    document.querySelectorAll('cart-notification').forEach(function (n) {
      var wrap = n.closest('.hdh__notify'); (wrap || n).remove();
    });
    var cartIcon = document.querySelector('.hdh__icon--cart');
    if (cartIcon) cartIcon.setAttribute('aria-haspopup', 'dialog');
  }

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SECTION = 'hd-cart-drawer';
  var BUBBLE = 'cart-icon-bubble';
  var DAYS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function addWorkdays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.'; }

  /* Mausrad: Seite unter dem Fenster nicht mitscrollen (auch nicht das weiche Scrollen der Startseite) */
  function canScroll(el, dy) {
    while (el && el !== document.body) {
      if (el.hasAttribute && el.hasAttribute('data-hdcart-body')) {
        if (el.scrollHeight <= el.clientHeight) return false;
        if (dy < 0) return el.scrollTop > 0;
        return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
      }
      el = el.parentElement;
    }
    return false;
  }
  window.addEventListener('wheel', function (e) {
    if (!html.classList.contains('hdcart-lock')) return;
    if (!canScroll(e.target, e.deltaY)) e.preventDefault();
  }, { passive: false, capture: true });

  class HdCart extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('[data-hdcart-panel]');
      this.busy = false;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKey.bind(this));
      this.setEta();

      /* Kopf-Symbol öffnet das Fenster statt zur Warenkorbseite zu springen */
      var self = this;
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        if (!a.closest('[data-hdh]')) return;
        var path = a.getAttribute('href').split('?')[0];
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        if (path !== cartUrl || location.pathname === cartUrl) return;
        e.preventDefault();
        self.open(a);
      });

      /* Wischen nach unten schließt am Handy */
      var startY = null, dy = 0;
      this.panel.addEventListener('touchstart', function (e) {
        var head = e.target.closest('.hdcart__head');
        startY = head ? e.touches[0].clientY : null; dy = 0;
      }, { passive: true });
      this.panel.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        self.panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
      }, { passive: true });
      this.panel.addEventListener('touchend', function () {
        if (startY === null) return;
        self.panel.style.transform = '';
        if (dy > 90) self.close();
        startY = null;
      });

      window.addEventListener('pageshow', function (e) { if (e.persisted) self.close(true); });
    }

    /* ---------- Schnittstelle für Dawn (product-form.js) und die Produktkarten ---------- */
    getSectionsToRender() { return [{ id: SECTION }, { id: BUBBLE }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(state) {
      this.apply(state && state.sections);
      var self = this;
      /* Auf der Produktseite erst die Flug-Animation ins Symbol zeigen, dann öffnen */
      var delay = (!reduce && document.querySelector('[data-hdp]')) ? 700 : 0;
      setTimeout(function () { self.open(self.activeElement); self.flashFirst(state && state.key); }, delay);
    }

    /* ---------- Öffnen / Schließen ---------- */
    open(trigger) {
      if (this.classList.contains('is-open')) return;
      var hdr = document.querySelector('[data-hdh]');
      if (hdr && hdr.hdh) { hdr.hdh.closeDrawer(); hdr.hdh.closeSearch(); hdr.hdh.show(); }
      this.lastFocus = (trigger && trigger.offsetParent) ? trigger : document.activeElement;
      this.hidden = false;
      void this.offsetWidth;
      this.classList.add('is-open');
      html.classList.add('hdcart-lock');
      var p = this.panel;
      setTimeout(function () { p.focus({ preventScroll: true }); }, reduce ? 0 : 320);
      this.setEta();
    }
    close(instant) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      html.classList.remove('hdcart-lock');
      var lf = this.lastFocus;
      if (lf && lf.focus && document.contains(lf)) lf.focus({ preventScroll: true });
    }

    onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); this.close(); return; }
      if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
      var f = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onClick(e) {
      var t = e.target;
      if (t.closest('[data-hdcart-close]')) { e.preventDefault(); this.close(); return; }
      var q = t.closest('[data-hdcart-qty]');
      var rm = t.closest('[data-hdcart-rm]');
      var add = t.closest('[data-hdcart-add]');
      if (q || rm) {
        var li = t.closest('[data-line]');
        if (!li) return;
        var cur = parseInt(li.querySelector('.hdcart__qty span').textContent, 10) || 0;
        var next = rm ? 0 : Math.max(0, cur + parseInt(q.getAttribute('data-hdcart-qty'), 10));
        if (next === 0) li.classList.add('is-leaving');
        this.change(li.getAttribute('data-line'), next, li);
        return;
      }
      if (add) { this.add(add.getAttribute('data-hdcart-add'), add); }
    }

    /* ---------- Server ---------- */
    request(url, body) {
      body.sections = [SECTION, BUBBLE].join(',');
      body.sections_url = location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    }
    change(line, qty, li) {
      if (this.busy) return;
      this.busy = true; this.classList.add('is-busy');
      var self = this;
      var base = (window.routes && window.routes.cart_change_url) || '/cart/change';
      this.request(base + '.js', { line: parseInt(line, 10), quantity: qty }).then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description);
        var go = function () { self.apply(res.j.sections); self.say(qty === 0 ? 'Artikel entfernt' : 'Menge geändert'); };
        if (qty === 0 && li && !reduce) setTimeout(go, 260); else go();
      }).catch(function (err) {
        if (li) li.classList.remove('is-leaving');
        self.say((err && err.message) || 'Das hat nicht geklappt. Bitte versuch es noch mal.');
      }).finally(function () { self.busy = false; self.classList.remove('is-busy'); });
    }
    add(id, btn) {
      if (this.busy) return;
      this.busy = true; this.classList.add('is-busy');
      if (btn) btn.classList.add('is-loading');
      var self = this;
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      this.request(base + '.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] }).then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description);
        self.apply(res.j.sections);
        self.flashFirst(res.j.items && res.j.items[0] && res.j.items[0].key);
        self.say('Hinzugefügt');
      }).catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        self.say((err && err.message) || 'Das hat nicht geklappt. Bitte versuch es noch mal.');
      }).finally(function () { self.busy = false; self.classList.remove('is-busy'); });
    }

    /* ---------- Neu zeichnen ---------- */
    apply(sections) {
      if (!sections) { this.refresh(); return; }
      var parser = new DOMParser();
      if (sections[SECTION]) {
        var doc = parser.parseFromString(sections[SECTION], 'text/html');
        var fresh = doc.querySelector('[data-hdcart-inner]');
        var freshRoot = doc.querySelector('[data-hdcart]');
        var inner = this.querySelector('[data-hdcart-inner]');
        if (fresh && inner) {
          var body = inner.querySelector('[data-hdcart-body]');
          var keep = body ? body.scrollTop : 0;
          inner.innerHTML = fresh.innerHTML;
          var nb = inner.querySelector('[data-hdcart-body]');
          if (nb) nb.scrollTop = keep;
        }
        if (freshRoot) this.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
        this.setEta();
      }
      if (sections[BUBBLE]) {
        var b = document.getElementById(BUBBLE);
        if (b) {
          var bdoc = parser.parseFromString(sections[BUBBLE], 'text/html');
          var cb = bdoc.querySelector('.cart-count-bubble');
          var out = cb ? cb.outerHTML : '';
          if (b.innerHTML.trim() !== out.trim()) b.innerHTML = out;
        }
      }
    }
    refresh() {
      var self = this;
      fetch(location.pathname + '?sections=' + SECTION + ',' + BUBBLE).then(function (r) { return r.json(); }).then(function (s) { self.apply(s); });
    }
    flashFirst(key) {
      if (!key) return;
      var li = this.querySelector('[data-key="' + key + '"]');
      if (!li) return;
      li.classList.remove('is-new'); void li.offsetWidth; li.classList.add('is-new');
    }
    say(msg) {
      var live = this.querySelector('[data-hdcart-live]');
      if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
    }
    setEta() {
      var el = this.querySelector('[data-hdcart-eta]');
      if (!el) return;
      var mn = parseInt(this.getAttribute('data-eta-min'), 10) || 2;
      var mx = parseInt(this.getAttribute('data-eta-max'), 10) || 5;
      var now = new Date();
      el.innerHTML = 'Bestellst du heute, ist es ca. <strong>' + fmt(addWorkdays(now, mn)) + ' – ' + fmt(addWorkdays(now, mx)) + '</strong> bei dir';
    }
  }

  customElements.define('cart-drawer', HdCart);

  /* Andere Fenster (Suche, Menü) haben Vorrang: Warenkorb schließen, wenn eins aufgeht */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hdcart]')) html.classList.remove('hdcart-lock');
  });
})();
